import Divider from '@mui/material/Divider';
import AnalyticsFileTable from './AnalyticsFileTable';
import { getStore } from '../../Store'


const GenAlgAnalyticsFiles = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("gen_alg_run_id")

    return (
        <div>
            <div style={{ fontSize: "40px" }}>{id} Analytics Files</div>
            <br/>
            <Divider/>
            <br/>
            <AnalyticsFileTable gen_alg_run={id} />
        </div>
    )
}

export default GenAlgAnalyticsFiles;